import React, { Fragment } from "react";
import { Mui } from "../libraries/material/";
import PropTypes from 'prop-types'

function ChipList(props = {}) {
  const { id, chips, chipProps, color, ...rest } = props;
  let className = rest?.className ? rest.className + " " : "";
  className += "display-flex width-100";

  const sharedChipStyles = (theme) => {
    const mode = theme.palette.mode
    const background = color || theme.palette.secondary[mode] 
    let styles = {
      primary: {
        backgroundColor: background,
        color: theme.palette.getContrastText(background),
      }
    }
    const contrastFn = (mode === "dark") ? Mui.darken : Mui.lighten
    const secondaryBg = contrastFn(background, .5)
    styles.secondary = {
      backgroundColor: secondaryBg,
      color: theme.palette.getContrastText(secondaryBg),
    }
    return styles.primary
  };

  return (
    <Mui.List component="dl" id={id} {...rest} className={className}>
      {chips.map((chip, index) => {
        const { primary, secondary } = chip;
        return (
          <Fragment key={`chip-${index}-${id}`}>
            <Mui.Chip
              sx={[
                sharedChipStyles,
                {
                  marginRight: "-1px",
                  borderRadius: "1.5rem 0 0 1.5rem",
                },
              ]}
              component="dt"
              label={primary}
            />
            <Mui.Chip
              sx={[
                sharedChipStyles,
                (theme) => {
                  let bgColor = theme.palette.type === "dark" 
                    ? theme.palette.background.paper 
                    : theme.palette.background.default
                  let color = theme.palette.getContrastText(bgColor)

                  return {
                    borderRadius: "0 1.5rem 1.5rem 0",
                    marginLeft: 0,
                    marginRight: theme.spacing(),
                    ["& ." + Mui.chipClasses.label]: {
                      backgroundColor: bgColor,
                      color,
                      borderRadius: "1em",
                      marginRight: ".5em",
                    },
                  }
                },
              ]}
              component="dd"
              label={secondary}
            />
          </Fragment>
        );
      })}
    </Mui.List>
  );
}

ChipList.defaultProps = {
  chips: [],
};

ChipList.propTypes = {
  id: PropTypes.string.isRequired
}

export default ChipList;
